module.exports = __webpack_public_path__ + "static/media/dailyTelegraph.c63b667d.svg";